module.exports = __webpack_public_path__ + "img/sprite-religions.6a98c9e.svg";